import { render, staticRenderFns } from "./index.vue?vue&type=template&id=c5671d94&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c5671d94')) {
      api.createRecord('c5671d94', component.options)
    } else {
      api.reload('c5671d94', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=c5671d94&", function () {
      api.rerender('c5671d94', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/official/components/rightcolumn/index.vue"
export default component.exports